import { render, staticRenderFns } from "./curriculumStudy.vue?vue&type=template&id=7f74f612&scoped=true"
import script from "./curriculumStudy.vue?vue&type=script&lang=js"
export * from "./curriculumStudy.vue?vue&type=script&lang=js"
import style0 from "./curriculumStudy.vue?vue&type=style&index=0&id=7f74f612&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f74f612",
  null
  
)

export default component.exports